import React from 'react';
import { useSpring, animated } from 'react-spring';
import styled from 'styled-components';
import { above } from '../../../style/util';
import { neutral } from '../../../style/colors';
import Spinner from '../../Spinner';
import { ILokalplan } from '../../../Interfaces/ILokalplan';
import HistoriskPlan from './HistoriskPlan';

const HistorikTopbar = (props: IHistorikTopbarProps) => {
  const {
    toggled,
    loading,
    historiskeLokalplaner,
    currentHistoriskeLokalplan,
    setCurrentHistoriskeLokalplan,
  } = props;
  const topbarAnimation = useSpring({
    // config: { duration: 150 },
    right: 0,
    top: toggled ? '0px' : '-115px',
    position: 'fixed',
    left: 0,
    backgroundColor: neutral[700],
    color: neutral[200],
    zIndex: 3,
    height: 115,
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    overflowX: 'hidden',
  });

  const renderHistorik = () => {
    if (loading)
      return (
        <div
          style={{
            height: 115,
            width: 200,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner />
        </div>
      );
    return (
      <>
        {historiskeLokalplaner.map((lokalplan, i) => {
          return (
            <HistoriskPlan
              key={i}
              lokalplan={lokalplan}
              first={i === 0}
              last={i === historiskeLokalplaner.length - 1}
              currentHistoriskeLokalplan={currentHistoriskeLokalplan}
              setCurrentHistoriskeLokalplan={setCurrentHistoriskeLokalplan}
            />
          );
        })}
      </>
    );
  };
  return (
    <animated.div style={topbarAnimation}>
      <Header>LOKALPLANENS HISTORIK</Header>
      <HistorikWrapper>{renderHistorik()}</HistorikWrapper>
      <PaddingRight>&nbsp;</PaddingRight>
    </animated.div>
  );
};

const Header = styled.div`
  flex: 0 0 145px;
  padding: 20px;
  ${(above as any).small`
    min-width: 244px;
  `}
`;

const HistorikWrapper = styled.div`
  /* flex: 1; */
  display: flex;
  overflow: auto;
  height: 115px;
  scrollbar-color: #627d98 #a4bad0; /*firefox*/
  ::-webkit-scrollbar {
    background-color: #a4bad0;
    height: 8px;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #627d98;
    border-radius: 5px;
  }
`;
const PaddingRight = styled.div`
  flex: 0 0 0px;
  ${(above as any).small`
    flex: 0 0 430px;
  `}
`;
interface IHistorikTopbarProps {
  toggled: boolean;
  historiskeLokalplaner: ILokalplan[];
  loading: boolean;
  currentHistoriskeLokalplan?: ILokalplan;
  setCurrentHistoriskeLokalplan?: Function;
}
export default HistorikTopbar;
